export const LOAD_TABLE_DATA_SUCCESS = 'LOAD_TABLE_DATA_SUCCESS';
export const LOAD_TABLE_DATA_FAILURE = 'LOAD_TABLE_DATA_FAILURE';
export const SELECTED_ROWS_PRICE_SUCCESS = 'SELECTED_ROWS_PRICE_SUCCESS';
export const LOAD_SERVICE_PRICE_SUCCESSFUL = 'LOAD_SERVICE_PRICE_SUCCESSFUL';


// WEBPACK FOOTER //
// ./src/actionTypes/operations.js